import { msg } from '@lingui/core/macro';
import type { RankPoint } from '@routes/sidebar/learning/api/learning.api.ts';
import { SCORE_TYPES } from '@routes/sidebar/learning/api/learning.api.ts';
import type { NotificationInstance } from 'antd/es/notification/interface';

import { showPointsToast } from './toast.tsx';
import { translateItem } from './translations.ts';

const codeToDescription = (code: string) => {
    switch (code) {
        case 'E1':
            return msg`Logged in today. Good to see you.`;
        case 'E2':
            return msg`5 days in a row! Strong streak.`;
        case 'E3':
            return msg`Welcome back! Restarting strong.`;
        case 'E4':
            return msg`3 days back in action! Keep it up.`;
        case 'L1':
            return msg`One more learning element done. Nice progress.`;
        case 'L2':
            return msg`Passed on first try! Great work.`;
        case 'L3':
            return msg`Great flow! 3 completed in one stretch.`;
        case 'L4':
            return msg`That’s focus! 7 completed back to back.`;
        case 'P1':
            return msg`First step taken. Keep the flow.`;
        case 'P2':
            return msg`Finished on time. Solid effort.`;
        case 'P3':
            return msg`Quiz and pathway completed on time. Well done.`;
        case 'P4':
            return msg`Finished late, but you got it done.`;
        case 'P5':
            return msg`Final quiz done. Completed after the due date.`;
        case 'R1':
            return msg`Half way there! Keep going strong`;
        case 'R2':
            return msg`All done and ahead of schedule. Impressive work!`;
        case 'R3':
            return msg`All completed, A little late, but progress counts.`;
        default:
            return '';
    }
};

export const rankPointToToast = (point: RankPoint, notify: NotificationInstance) =>
    showPointsToast(
        notify,
        translateItem(msg`You earned ${point.value} Points!`),
        translateItem(codeToDescription(point.code)),
        point.value,
        point.scoreType === SCORE_TYPES.Bonus,
    );
